export default class GetCompanyDTO {
    constructor(
        public id: string,
        public name: string,
        public logo: string|null,
        public banner: string|null,
        public textContent: string|null,
        public scriptContent: string|null
    ) {}
}